import { useMutation, useQuery, useQueryClient } from 'react-query';
import { useAccessToken } from 'utils/auth';
import { createShift, deleteShift, fetchShift } from './api';
import { CreateShiftFormData } from './types';

export const useShiftQuery = (
  token: string | undefined,
  shiftId: string | undefined
) =>
  useQuery(['shift', token, shiftId], () => fetchShift(token, shiftId), {
    enabled: !!(token && shiftId)
  });

export const useCreateShiftMutation = (periodId: string | undefined) => {
  const { token } = useAccessToken();
  const queryClient = useQueryClient();

  return useMutation(
    ['createShift', token, periodId],
    (formData: CreateShiftFormData) => createShift(token, periodId, formData),
    {
      onSuccess: () => {
        void queryClient.invalidateQueries(['weekDetails']);
        void queryClient.invalidateQueries(['workPeriods']);
      }
    }
  );
};

export const useDeleteShiftMutation = (shiftId: string | undefined) => {
  const { token } = useAccessToken();

  const queryClient = useQueryClient();

  return useMutation(
    ['deleteShift', token, shiftId],
    () => deleteShift(token, shiftId),
    {
      onSuccess: () => {
        void queryClient.invalidateQueries(['weekDetails']);
        void queryClient.invalidateQueries(['workPeriods']);
      }
    }
  );
};
